import { BaseAPI } from "@/api/baseAPI";
import type { OrganisationScale } from "@/types";

class OrganisationScaleAPI extends BaseAPI<OrganisationScale> {
  constructor() {
    super("scale");
  }
}

export default new OrganisationScaleAPI();
